import {ValueObject} from '@s-ui/domain'

export class MakesListValueObject extends ValueObject {
  /**
   * @param {Array<MakeEntity>} items
   * */
}
